var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0 mt-0",staticStyle:{"height":"100%"},attrs:{"id":"statsModule","fill-height":"","fluid":"","grid-list-xl":""}},[_c('buyerDashboardOverallStats',{attrs:{"stats":_vm.statistics[0]}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }